import { render } from "./Desktop.vue?vue&type=template&id=3937bf8d&scoped=true"
import script from "./Desktop.vue?vue&type=script&lang=js"
export * from "./Desktop.vue?vue&type=script&lang=js"

import "./Desktop.vue?vue&type=style&index=0&id=3937bf8d&lang=less&scoped=true"

import exportComponent from "E:\\CODE\\jb-oa\\jb-oa-web\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3937bf8d"]])

export default __exports__